import { useQuery } from '@apollo/client';
import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { Alert, Box, Button, Loader, Menu, Typography } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { PromptItem } from './PromptItem';
import { SelectPromptDocument } from './SelectPrompt.gql';
export function SelectPrompt(props) {
    const { onSelect } = props;
    const { data, loading, error } = useQuery(SelectPromptDocument);
    const { prompts = [] } = (data === null || data === void 0 ? void 0 : data.documentAssistantPrompts) || {};
    const publicPrompts = prompts.filter((prompt) => prompt.isPublic);
    const privatePrompts = prompts.filter((prompt) => !prompt.isPublic);
    const isEmpty = prompts.length === 0;
    if (error) {
        return (<Alert appearance="danger" message={t({
                message: 'Something went wrong, please reload the page and try again',
                comment: 'Document approval check - select prompt field - failed to load data to display',
            })}/>);
    }
    return (<Menu.Root target={<Button $stretch appearance="primary" size="small" disabled={loading}>
          {loading ? <Loader /> : <Falcon icon="sparkles"/>}
          <Trans comment="Document approval check - Run approval check button label">Run approval check</Trans>
        </Button>}>
      {privatePrompts.length > 0 && (<Menu.Label>
          <Trans comment="Document approval check - Select prompt menu - My prompts label">My prompts</Trans>
        </Menu.Label>)}

      {privatePrompts.map((prompt) => (<PromptItem key={prompt.id} {...prompt} onClick={onSelect}/>))}

      {publicPrompts.length > 0 && (<Menu.Label>
          <Trans comment="Document approval check - Select prompt menu - Public prompts label">Public</Trans>
        </Menu.Label>)}

      {publicPrompts.map((prompt) => (<PromptItem key={prompt.id} {...prompt} onClick={onSelect}/>))}

      {isEmpty && (<Box alignItems="center" justifyContent="center" py="xl">
          <Typography $appearance="100" $fontSize="small">
            <Trans comment="Document approval check - select prompt menu - no approval workflow prompts found">
              No approval workflow prompts found
            </Trans>
          </Typography>
        </Box>)}
    </Menu.Root>);
}
